module.exports = __webpack_public_path__ + "static/media/社区团购_19.7f15aa70.jpg";